import React from "react";
import { PasswordGate } from "@/components/PasswordGate/PasswordGate";
import { InvestorContent } from "@/components/Investors/InvestorContent";
import { useGatedResource } from "@/hooks/useGatedResource";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/investors`;

export default function InvestorsPage() {
  const gate = useGatedResource({
    storageKey: "akali_investor_session",
    authUrl: `${API}/auth`,
    logoutUrl: `${API}/logout`,
    resourceUrl: `${API}/content`,
  });

  if (gate.checking) return <div className="investor-gate" data-testid="investor-checking" />;
  if (gate.data) return <InvestorContent content={gate.data} onLogout={gate.logout} />;
  return (
    <PasswordGate
      idPrefix="investor"
      eyebrow="INVESTIDORES"
      title="Área restrita"
      description="Acesso exclusivo para investidores e parceiros estratégicos."
      footnote="Para credenciais, entre em contato com a equipe."
      gate={gate}
    />
  );
}
